import { Button } from '@mui/material';

// Generate popup buttons based on edit state
export const createPopupButtons = (isEdit, saveEvent) => {
    if (isEdit) {
        return (
            <>
                <Button
                    sx={{
                        border: '1px solid #3498B7',
                        backgroundColor: 'white',
                        color: '#3498B7',
                        '&:hover': {
                            backgroundColor: '#3498B7',
                            color: 'white',
                            borderColor: '#2980B9',
                        },
                    }}
                    onClick={saveEvent}
                    variant="outlined"
                    color="secondary"
                >
                    Save
                </Button>
            </>
        );
    } else {
        return (
            <Button
                sx={{
                    border: '1px solid #3498B7',
                    backgroundColor: 'white',
                    color: '#3498B7',
                    '&:hover': {
                        backgroundColor: '#3498B7',
                        color: 'white',
                        borderColor: '#2980B9',
                    },
                }}
                onClick={saveEvent}
                variant="outlined"
                color="secondary"
            >
                Add
            </Button>
        );
    }
};

// Generate header text based on edit state
export const createHeaderText = (isEdit) => {
    return isEdit ? 'Edit event' : 'New Event';
};

// Handle popup close
export const createOnClose = (setOpen, tempEventRef = null) => {
    return () => {
        // Clean up temporary event if it exists
        if (tempEventRef && tempEventRef.current) {
            const { event, instance } = tempEventRef.current;
            if (instance && instance.removeEvent) {
                instance.removeEvent(event);
            }
            tempEventRef.current = null;
        }
        setOpen(false);
    };
};

// Handle delete click
export const createOnDeleteClick = (deleteLocalEvent, tempEvent) => {
    return () => {
        console.log('Delete button clicked!');
        console.log('tempEvent:', tempEvent);
        console.log('tempEvent.current:', tempEvent?.current);
        console.log('deleteLocalEvent function:', deleteLocalEvent);
        
        if (tempEvent && tempEvent.current) {
            console.log('Calling deleteLocalEvent with event:', tempEvent.current);
            deleteLocalEvent(tempEvent.current);
        } else {
            console.warn('No event to delete: tempEvent is null or undefined');
        }
    };
};
